import { render, staticRenderFns } from "./overDelivery.vue?vue&type=template&id=55ed9ee2"
import script from "./overDelivery.vue?vue&type=script&lang=js"
export * from "./overDelivery.vue?vue&type=script&lang=js"
import style0 from "./overDelivery.vue?vue&type=style&index=0&id=55ed9ee2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports